import { Icon, IconNames, IconProps } from "./icon";

export type {
    IconNames, IconProps
}

export default Icon;